




















































import { Component, Vue, Ref } from "vue-property-decorator"
import CandidateProfileRead from "@/pages/Candidate/Profile/CandidateProfileRead.vue"
import CandidateProfileUpdate from "@/pages/Candidate/Profile/CandidateProfileUpdate.vue"
import { mapState } from "vuex"
import _ from "lodash"

@Component({
  components: {
    CandidateProfileRead,
    CandidateProfileUpdate,
  },
  computed: {
    ...mapState("CandidateProfile", {
      questionGroups: "questionGroups",
    }),
    ...mapState({
      loading: "loading",
    }),
  },
})
export default class CandidateQuestionnaireCandidateProfileCheck extends Vue {
  @Ref() candidateProfileUpdateComponent!: CandidateProfileUpdate

  questionGroups!: []

  updateScene = false

  isReview = false

  get isEmptyCandidateProfile() {
    return _.isEmpty(this.questionGroups)
  }

  get isCandidateProfileCompleted() {
    return this.questionGroups
      .map((qg: Model) => qg.progress)
      .every((progress) => progress == 1)
  }

  get isXs() {
    return this.$vuetify.breakpoint.xs
  }

  get reviewAnswerBtnLabel() {
    return this.isXs ? "Review" : "Review Answers"
  }

  async viewCandidateProfile() {
    await this.candidateProfileUpdateComponent.read()
  }

  emitConfirm() {
    this.$emit("confirm")
  }
}
